import { ResourceType } from './resource-type';

/**
 * The resource type for BrowseDefinition
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const BROWSE_DEFINITION = new ResourceType('browse');
